var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pi-modal__container"},[_c('PIModalHeader',{attrs:{"position":_vm.position}}),_c('PIModalControls',{attrs:{"position":_vm.position}}),_c('PIModalFooter',{attrs:{"positionNumber":_vm.position.positionNumber},on:{"update:show-pi-modal":function($event){return _vm.$emit('update:show-pi-modal', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }